import {observable} from 'mobx';

class User {
  id = null;

  @observable
  name;

  @observable
  email;

  @observable
  nickName;

  @observable
  phone;

  @observable
  phoneArea;

  @observable
  userPhone;

  createdTime;

  type;

  domain;

  accountStartTime;

  accountExpireTime;

  adminLevel;

  roleTypes;

  structureTypes;

  userGroupTypes;

  constructor(store, id) {
    this.id = id;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.email = json.email;
    this.nickName = json.nickName;
    this.phone = json.phone;
    this.phoneArea = json.phoneArea || '+86';
    this.type = json.type;
    this.domain = json.domain;
    this.userPhone = this.phone ? `${this.phoneArea} ${this.phone}` : '';
    this.accountStartTime = json.accountStartTime;
    this.accountExpireTime = json.accountExpireTime;
    this.adminLevel = json.adminLevel;
    this.createdTime = json.createdTime;
    this.roleTypes = json.roleTypes;
    this.structureTypes = json.structureTypes;
    this.userGroupTypes = json.userGroupTypes;
  }
}

export default User;
